import { MapPin, Phone, Clock, MessageCircle, Mail } from "lucide-react";
import { waGeneralLink } from "@/lib/whatsapp";

export default function Contact() {
  const mapsQuery = encodeURIComponent("Khasim Trendz, 2B, Door No 25/1, Near 5 Roads Centre, Jagannadhapuram, Buttaipet, Machilipatnam, Andhra Pradesh");
  const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${mapsQuery}`;
  const mapsEmbed = `https://www.google.com/maps?q=${mapsQuery}&output=embed`;

  return (
    <div data-testid="contact-page">
      <section className="border-b-[3px] border-black bg-[var(--candy-purple)] text-white candy-dots">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-14 md:py-20">
          <div className="nb-pill inline-block mb-4 !text-black">SAY HI</div>
          <h1 className="font-display font-black uppercase text-5xl md:text-7xl tracking-tight">Visit. Chat. Shop.</h1>
          <p className="mt-4 text-lg md:text-xl max-w-2xl text-white/90">Drop into our Buttaipet store, or just hit us up on WhatsApp — we reply faster than you can say "candy crush".</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 md:px-8 py-12 grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Address */}
        <div className="nb-card p-6 bg-white" data-testid="contact-address-card">
          <div className="w-12 h-12 rounded-full bg-[var(--primary)] text-white border-[3px] border-black flex items-center justify-center mb-4 shadow-[3px_3px_0_0_#0A0A0A]">
            <MapPin strokeWidth={2.5} />
          </div>
          <div className="font-display font-black uppercase text-xl mb-2">Store Address</div>
          <p className="text-black/80 mb-4">
            Khasim Trendz<br/>
            2B, Door No 25/1, Near 5 Roads Centre,<br/>
            Jagannadhapuram, Buttaipet,<br/>
            Machilipatnam,<br/>
            Andhra Pradesh, India
          </p>
          <a href={mapsUrl} target="_blank" rel="noreferrer" className="nb-pill inline-block" data-testid="open-maps-btn">Open in Google Maps</a>
        </div>

        {/* WhatsApp */}
        <div className="nb-card p-6 bg-[var(--secondary)]" data-testid="contact-wa-card">
          <div className="w-12 h-12 rounded-full bg-[var(--whatsapp)] text-white border-[3px] border-black flex items-center justify-center mb-4 shadow-[3px_3px_0_0_#0A0A0A]">
            <MessageCircle strokeWidth={2.5} />
          </div>
          <div className="font-display font-black uppercase text-xl mb-2">WhatsApp</div>
          <p className="text-black/80 mb-1">Fastest way to reach us:</p>
          <a href="https://wa.me/919885544389" target="_blank" rel="noreferrer" className="font-display font-black text-2xl underline decoration-[3px] decoration-black underline-offset-4">+91 98855 44389</a>
          <div className="mt-4">
            <a href={waGeneralLink()} target="_blank" rel="noreferrer" className="nb-btn bg-[var(--whatsapp)] text-white" data-testid="contact-wa-btn">Start Chat</a>
          </div>
        </div>

        {/* Hours */}
        <div className="nb-card p-6 bg-white" data-testid="contact-hours-card">
          <div className="w-12 h-12 rounded-full bg-[var(--accent)] text-white border-[3px] border-black flex items-center justify-center mb-4 shadow-[3px_3px_0_0_#0A0A0A]">
            <Clock strokeWidth={2.5} />
          </div>
          <div className="font-display font-black uppercase text-xl mb-2">Store Hours</div>
          <ul className="text-black/80 space-y-1">
            <li><b>Mon – Sat:</b> 10:00 AM – 9:30 PM</li>
            <li><b>Sunday:</b> 11:00 AM – 9:00 PM</li>
          </ul>
        </div>
      </section>

      {/* Map */}
      <section className="max-w-7xl mx-auto px-5 md:px-8 pb-16">
        <div className="nb-card overflow-hidden">
          <iframe
            data-testid="map-iframe"
            title="Khasim Trendz Map"
            src={mapsEmbed}
            className="w-full h-[420px] border-0"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 md:px-8 pb-20 grid grid-cols-1 md:grid-cols-2 gap-6">
        <a href="tel:+919885544389" className="nb-card p-6 bg-[var(--primary)] text-white flex items-center gap-4" data-testid="contact-call-card">
          <Phone strokeWidth={2.5} size={32} />
          <div>
            <div className="font-display font-black uppercase text-2xl">Call Us</div>
            <div>+91 98855 44389</div>
          </div>
        </a>
        <a href={waGeneralLink()} target="_blank" rel="noreferrer" className="nb-card p-6 bg-black text-white flex items-center gap-4" data-testid="contact-message-card">
          <Mail strokeWidth={2.5} size={32} />
          <div>
            <div className="font-display font-black uppercase text-2xl">Message Us</div>
            <div>We reply within minutes on WhatsApp</div>
          </div>
        </a>
      </section>
    </div>
  );
}
